<lib-page-heading text="Update Fees / True Cost"></lib-page-heading>
<div class="row mb-4">
    <div class="col-6 offset-3">
        <lib-user-custom-product-settings></lib-user-custom-product-settings>
    </div>
</div>
